<template>
  <div class="ec-line032">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ $t('ec-line032.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="flex flex-row w-full justify-center">
      <h1 class="text-primary text-xl">{{ title }}</h1>
    </div>
    <div class="w-full mt-8">
      <p class="text-left text-black leading-normal">{{ $t('ec-line032.content.hint1') }}</p>
      <p class="text-left text-black leading-normal">{{ $t('ec-line032.content.hint2') }}</p>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-position="top" class="t-form no-required mt-8">
      <el-form-item :label="$t('common.memberInformation.email')" prop="email">
        <el-input v-model="form.email" :placeholder="$t('common.informationPlaceholder.emailPlaceholder')" />
      </el-form-item>
      <div class="w-full mx-auto text-center">
        <el-button class="submit-btn" :disabled="disabled" @click="onSend">{{ $t('common.action.send') }}</el-button>
      </div>
      <div class="w-full mx-auto text-center mt-2">
        <el-button class="cancel-btn" @click="onBack">{{ $t('common.action.cancel') }}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { AuthService } from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  mixins: [BreadcrumbMixin],
  data() {
    return {
      title: this.$t('ec-line032.title'),
      form: {
        email: '',
      },
      rules: {
        email: [
          this.Utils.validate.required(this.$t('common.validate.field.email')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.email')),
        ],
      },
      disabled: false,
    }
  },
  methods: {
    onSend() {
      this.$refs.form.validate((valid) => {
        if (!valid) return

        this.disabled = true

        AuthService.sendResetPassword(this.form.email)
          .then(() => this.$router.push(this.$routePage.EC_LINE033))
          .catch((error) => {
            this.handleError(error)
            this.disabled = false
          })
      })
    },
    onBack() {
      this.$router.push(this.$routePage.EC_LINE031)
    },
  },
  metaInfo() {
    return {
      title: this.title,
    }
  },
}
</script>
<style lang="scss" scope>
@import '@/assets/css/pages/ec-line032.scss';
</style>
